import {
  PlatoChooseConsultRequest,
  PlatoContextQuery,
  PlatoGiveAnswerRequest,
  PlatoPreviousQuestionRequest,
  PlatoStartQuestionnaireRequest,
} from "@shared/dtos/requests/platoRequests.dto"
import { DefaultResponse } from "@shared/dtos/responses/commonResponses.dto"
import {
  PlatoEndResponse,
  PlatoPreviousQuestionResponse,
  PlatoQuestionResponse,
  PlatoQuestionnaireResponse,
  PlatoQuestionnaireWithComplaintResponse,
  PlatoRemainingQuestionsResponse,
  PlatoSearchResponse,
} from "@shared/dtos/responses/platoResponses.dto"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getQuestionnaires = (params: PlatoContextQuery): Promise<PlatoQuestionnaireWithComplaintResponse[]> =>
  axiosPatient({
    url: "/patient/plato/questionnaires",
    params,
    method: "get",
  }).then((resp) => resp.data)

export const searchQuestionnaires = (params: PlatoContextQuery): Promise<PlatoSearchResponse> =>
  axiosPatient({
    url: "/patient/plato/questionnaires/search",
    params,
    method: "get",
  }).then((resp) => resp.data)

export const getPopularQuestionnaires = (
  params: PlatoContextQuery
): Promise<PlatoQuestionnaireWithComplaintResponse[]> =>
  axiosPatient({
    url: "/patient/plato/questionnaires/popular",
    params,
    method: "get",
  }).then((resp) => resp.data)

export const getAdministrativeQuestionnaires = (params: PlatoContextQuery): Promise<PlatoQuestionnaireResponse[]> =>
  axiosPatient({
    url: "/patient/plato/administrative",
    params,
    method: "get",
  }).then((resp) => resp.data)

export const start = (data: PlatoStartQuestionnaireRequest): Promise<PlatoQuestionResponse | PlatoEndResponse> =>
  axiosPatient({
    url: "/patient/plato/start",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const answer = (data: PlatoGiveAnswerRequest): Promise<PlatoQuestionResponse | PlatoEndResponse> =>
  axiosPatient({
    url: "/patient/plato/answer",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const previous = (data: PlatoPreviousQuestionRequest): Promise<PlatoPreviousQuestionResponse> =>
  axiosPatient({
    url: "/patient/plato/previous",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const choose = (data: PlatoChooseConsultRequest): Promise<DefaultResponse> =>
  axiosPatient({
    url: "/patient/plato/choose",
    method: "post",
    data,
  }).then((resp) => resp.data)

export const getRemainingQuestions = (sessionId: string): Promise<PlatoRemainingQuestionsResponse> =>
  axiosPatient({
    url: `/patient/plato/sessions/${sessionId}/remaining-questions`,
    method: "get",
  }).then((resp) => resp.data)

/**
 * Get the step the patient is currently at for the given session: the question they are answering,
 * or the end response once the questionnaire has ended
 * @param sessionId - The session id
 */
export const getCurrentStep = (sessionId: string): Promise<PlatoQuestionResponse | PlatoEndResponse> =>
  axiosPatient({
    url: `/patient/plato/sessions/${sessionId}/current-question`,
    method: "get",
  }).then((resp) => resp.data)
